import {FactoryID} from "../../model-factory/type-interface/ModelFactoryType";
import {IPopulateIDs} from "../../model-factory/type-interface/ModelFactoryInterface";
import ApiRequestVO from "../../manager/api/ApiRequestVO";
import {IAnyObject} from "../../common/SimpleInterface";
import ApiError from "../../manager/api/ApiError";
import {getManager} from "../../manager/Manager";
import DataChoice from "../../model-factory/basic/data/DataChoice";
import DataFactory from "../../model-factory/basic/data/DataFactory";
import {LocateSearchParams} from "./LocateDataFactory";
import {SearchBasicDataModel} from "../search/SearchBasicDataFactory";

export class LocateCountryDataChoice extends DataChoice
{
    count:number;

    constructor(object:IAnyObject)
    {
        super(object);

        this.count = object.count && !isNaN(object.count) ? parseInt(object.count) : 0;
    }
}

export class LocateCountryDataModel extends SearchBasicDataModel
{

    searchParams:LocateSearchParams = new LocateSearchParams();

    choiceList(choiceOrder?:string[]): LocateCountryDataChoice[]
    {
        return super.choiceList(choiceOrder) as LocateCountryDataChoice[];
    }

    getPopulateRequestVO(): ApiRequestVO|null
    {
        const requestVO = new ApiRequestVO(true);
        if(!this.searchParams.organisationID){
            requestVO.endpoint = "/post/"+this.searchParams.postType+"/count_meta_keys";
        } else {
            requestVO.endpoint = "/post/organisation/"+this.searchParams.organisationID+"/"+this.searchParams.postType+"/count_meta_keys";
        }
        requestVO.params = {
            meta_keys: ["country"],
            require_location: this.searchParams.requireLocation
        };

        return requestVO;
    }

    populateWithRequestResponse(response: IAnyObject, replaceData:boolean): ApiError | null
    {
        let error =  super.populateWithRequestResponse(response, replaceData);
        if(error){
            return error;
        }
        const entryCounts:IAnyObject= response.count?.country ?? {};
        const objectArray:IAnyObject[] = [];

        const fullLocationCountryList = getManager().config.locationCountryStore.list;
        for(let i = 0; i < fullLocationCountryList.length; i++)
        {
            const country = fullLocationCountryList[i];
            const count = parseInt(entryCounts[country.key] ?? "0");
            if(count){
                objectArray.push({
                    id: country.key,
                    name: country.value,
                    count: count
                })
            }
        }

        this.populateChoiceList(objectArray, replaceData);

        return null;
    }
}

export default class LocateCountryDataFactory extends DataFactory
{

    id: FactoryID = "locate_country_data";

    birth(id: string): LocateCountryDataModel
    {
        return new LocateCountryDataModel(id);
    }

    birthDataChoice(object:IAnyObject): LocateCountryDataChoice
    {
        return new LocateCountryDataChoice(object);
    }

    getLocateCountryDataModel(searchParams:LocateSearchParams): LocateCountryDataModel
    {
        const populateIDs:IPopulateIDs = {
            post_type: searchParams.postType ?? undefined,
            locate_require_location: searchParams.requireLocation
        };
        return this.requireModel(populateIDs) as LocateCountryDataModel;
    }
}